// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__JkP-8","slickslide":"carousel_slickslide__UO3Lr","slideImg":"carousel_slideImg__3NFDP"};